import React from 'react';

export function TermsPage() {
  return (
    <div className="page-content">
      <section className="hero is-medium about-hero">
        <div className="hero-body">
          <div className="container has-text-centered">
            <h1 className="title is-2 has-text-white">Terms of Service</h1>
            <p className="has-text-grey-light">Last updated: May 2026</p>
          </div>
        </div>
      </section>

      <section className="section about-section">
        <div className="container">
          <div className="columns is-centered">
            <div className="column is-8">
              <div className="content" style={{ color: "#c4c4c4" }}>
                <h2 className="has-text-white">1. Agreement to Terms</h2>
                <p>By accessing or using the Sitech eSports website and services, you agree to be bound by these Terms of Service. If you do not agree, please do not use our services.</p>

                <h2 className="has-text-white">2. Services</h2>
                <p>Sitech eSports provides simulation-powered esports pricing infrastructure via API to betting operators and sportsbook platforms. Access to our API and pricing feeds is subject to a separate commercial agreement.</p>

                <h2 className="has-text-white">3. Use of Website</h2>
                <p>You may use our website for lawful purposes only. You agree not to:</p>
                <ul>
                  <li>Use the website in any way that violates applicable laws or regulations</li>
                  <li>Attempt to gain unauthorised access to our systems or data</li>
                  <li>Interfere with or disrupt the website or its infrastructure</li>
                  <li>Scrape, copy, or reproduce content without permission</li>
                </ul>

                <h2 className="has-text-white">4. Intellectual Property</h2>
                <p>All content, software, algorithms, models, and data provided by Sitech eSports are our proprietary intellectual property. You may not reproduce, distribute, or create derivative works without our written consent.</p>

                <h2 className="has-text-white">5. API Usage</h2>
                <p>Use of our API is governed by a separate API Agreement. Unauthorised use of our API, including exceeding rate limits, reverse engineering, or redistribution of pricing data, is strictly prohibited.</p>

                <h2 className="has-text-white">6. Disclaimer</h2>
                <p>Our services are provided "as is" without warranties of any kind. While we strive for accuracy in our pricing models, we do not guarantee the accuracy of any probabilities, odds, or predictions. Our services are intended for licensed betting operators only and should not be used as personal betting advice.</p>

                <h2 className="has-text-white">7. Limitation of Liability</h2>
                <p>To the maximum extent permitted by law, Sitech eSports shall not be liable for any indirect, incidental, or consequential damages arising from your use of our services, including but not limited to financial losses from betting activities.</p>

                <h2 className="has-text-white">8. Termination</h2>
                <p>We reserve the right to suspend or terminate access to our services at any time, with or without notice, for any reason including breach of these terms.</p>

                <h2 className="has-text-white">9. Governing Law</h2>
                <p>These terms are governed by the laws of England and Wales. Any disputes shall be subject to the exclusive jurisdiction of the courts of England and Wales.</p>

                <h2 className="has-text-white">10. Changes to Terms</h2>
                <p>We may update these terms from time to time. Continued use of our services after changes constitutes acceptance of the updated terms.</p>

                <h2 className="has-text-white">11. Contact</h2>
                <p>For questions about these Terms of Service, contact us at <a href="mailto:hello@sitechesports.com" style={{ color: "#6ee7b7" }}>hello@sitechesports.com</a>.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
